<template>
    <div class="play" ref="play">
        <div class="x-right-close close el-icon-close" @click="close"></div>
    </div>
</template>

<script>
export default {
  name: 'MyVideo',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.initPlay(this.url); 
  },
  methods: {
    /**
         * 初始化播放器
         * @param {String} url 视频地址
         */
    initPlay(url) {
      new ChimeePlayer({
        wrapper: '.play', // video dom容器
        src: url,
        controls: true
      });
      let video = this.$refs.play.querySelector('video');
      video.addEventListener('canplaythrough', () => { // 监听视频资源加载完毕
        let w = video.offsetWidth;
        let h = video.offsetHeight;
        if (h > w) {
          video.style.width = 'auto';
          video.style.height = '100%';
        }
      }); 
    },

    close() {
      this.$video.close();
    }
  },
};
</script>

<style lang="scss" scoped>
    .play {
        position: relative;
        min-width: 1000px;
        height: 600px;
        background-color: #000;

        .close {
            right: -30px;
            top: -30px;
        }
    }
</style>
<style lang="scss">
    .play {

        container {
            position: absolute;
            width: 100%;
            top: 0;
            bottom: 0;
        }

        video {
            display: block;
            margin: auto;
        }
    }
</style>